export enum LocationType {
    Urban = 1,
    Suburban = 2,
    Rural = 3,
}

export const LocationTypes = [
    {
        id: LocationType.Urban,
        name: 'Urban',
    },
    {
        id: LocationType.Suburban,
        name: 'Suburban',
    },
    {
        id: LocationType.Rural,
        name: 'Rural',
    },
];

export const LocationTypeOptions = {
    [LocationType.Urban]: 'Urban',
    [LocationType.Suburban]: 'Suburban',
    [LocationType.Rural]: 'Rural',
};
